import { Component, OnInit } from '@angular/core';
import { IUser } from '../../shared/classes/user';
import { SystemService } from '../../services/system.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';


@Component({
  templateUrl: './user.component.html'
})
export class UserComponent implements OnInit {

  appealsUserList: IUser[];
  allAppealsUsers: IUser[];
  myUser: IUser = {
    id: 0,
    emailAddress: '',
    firstName: '',
    lastName: '',
    userType: '',
    isActive: true,
    username: '',
    lastLoginDt: '',
  };
  userType: string;  // this is userType of logged on user for checking Read-Only
  userTypeList = [];
  userTypeListAssessor = ['Assessor', 'Assessor-Supervisor', 'Assessor-Manager', 'Assessor-ReadOnly'];
  userTypeListCoB = ['Administrator', 'Clerk of the Board', 'ReadOnly', 'Assessor-Manager'];
  userTypeListALL = ['Administrator', 'Clerk of the Board', 'ReadOnly','Assessor', 'Assessor-Supervisor', 'Assessor-Manager', 'Assessor-ReadOnly' ];

  isNewEntry = false;

  displayState: any = {
    workingDiv: false,
    userDiv: false,
    gridDiv: true,
    editUserDiv: false,
    saveDisabled: false
  };

  activeUserOnly = false;


  constructor(private systemService: SystemService, private messageService: MessageService,
              private confirmationService: ConfirmationService, private utilService: UtilitiesService,
              private cookieService: CookieService) { }

  ngOnInit() {
    this.userTypeList = this.userTypeListALL; // for NOW, let's default to ALL types (CoB + Assessor)
    this.displayState.gridDiv = true;
    this.displayState.userDiv = false;
    this.displayState.editUserDiv = false;
    this.loadUserList();
  }

  isMgrLevel() {
    // determine if user type is "manager" level, i.e. Administrator or Clerk of the Board
    return true;
  }

  isAssessorMgr() {
    // determine if user type is Assessor-Manager
  }
  loadUserList() {
    this.displayState.workingDiv = true;
    this.systemService.getUserList().subscribe (data => {
      this.allAppealsUsers = [];
      this.allAppealsUsers = data;
      this.appealsUserList = [];
      this.filterOnStatus();
      this.displayState.workingDiv = false;
    });
  }

  filterOnStatus() {
    // work from last downloaded list of ALL users so we don't have to make another call...
    const activeOnly = this.activeUserOnly;

    let appealsUserList = this.allAppealsUsers.filter(t => {
      let hit = ( activeOnly === true && t.isActive == true) || (activeOnly === false);
      return hit ? t : null;
    });
    this.appealsUserList = [];
    this.appealsUserList = appealsUserList;
  }

  onSelect(user: IUser) {
    // get the user's data; from grid or from API call??
    //
    // now, display the edit User form
    this.displayState.gridDiv = false;
    this.displayState.userDiv = true;
    this.isNewEntry = false;
    // set user data for display
    this.myUser.id = user.id;
    this.myUser.emailAddress = user.emailAddress;
    this.myUser.firstName = user.firstName;
    this.myUser.lastName = user.lastName;
    this.myUser.userType = user.userType;
    this.myUser.isActive = user.isActive;
    //
    this.displayState.editUserDiv = true;
    return true;
  }

  newUser() {
    this.displayState.gridDiv = false;
    this.displayState.userDiv = true;
    this.isNewEntry = true;
    this.displayState.editUserDiv = true;
    // set user data for display
    this.myUser.id = 0;
    this.myUser.emailAddress = '';
    this.myUser.firstName = '';
    this.myUser.lastName = '';
    this.myUser.userType = '';
    this.myUser.isActive = true;
    //
    return true;
  }

  saveUser() {
    // validate data...
    if (this.validateUserData() === false ) {
      return true;
    }
    this.displayState.saveDisabled = true;  // so they can't click on the Save button again...
    // save user data
    this.systemService.saveUser(this.myUser).subscribe (data => {
      // once we get a response, hide the Edit window
      this.displayState.userDiv = false;
      this.displayState.editUserDiv = false;
      this.displayState.saveDisabled = false;
      // display grid div
      this.displayState.gridDiv = true;
      this.showToast({severity: 'success', summary: '', detail: 'User data updated.'});
      // refresh the grid/list
      this.loadUserList();
    });

    //
    return true;
  }

  validateUserData() {
    let retVal = true;
    // validate required user data; base it on value of any element w/ prd-required class??
    if ((this.myUser.emailAddress === '') || (this.myUser.lastName === '') || (this.myUser.userType === '')) {
      this.showToast({severity: 'error', summary: '', detail: 'Required items are missing.'});
      return false;
    } else if (this.myUser.emailAddress.indexOf('@') < 0) {
      this.showToast({severity: 'error', summary: '', detail: 'Email address MUST contain @.'});
      return false;
    } else if (this.isDuplicateUser(this.myUser)) {
      this.showToast({severity: 'error', summary: '', detail: 'Email already being used!'});
      return false;
    }
    // DURING TESTING - ALWAYS RETURN FALSE!!!
    return true;
  }

  isDuplicateUser(user) {
    this.utilService.doAudit(user, 'looking for duplicate user:');
    // determine if duplicate user (i.e. one w/ same email address, but different id)
    let dupUser = this.allAppealsUsers.filter(t => {
      let hit = ( (t.emailAddress === user.emailAddress) && (t.id !== user.id) );
      return hit ? t : null;
    });
    this.utilService.doAudit(dupUser, 'dup list:');
    // IFF we found at least one matching entry, then identify the current user as a duplicate!
    return dupUser.length > 0;
  }

  deleteUser(user: IUser) {
    this.confirmationService.confirm({
        message: 'Do you want to delete this User?',
        header: 'Delete Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.systemService.deleteUser(user).subscribe(data => {
            this.showToast({severity: 'success', detail: 'User has been DELETED.', summary: ''});
            this.loadUserList();
          });
        },
        reject: () => {
          this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
        }
    });

    return true;
  }

  cancelEntry() {
    this.displayState.userDiv = false;
    this.displayState.editUserDiv = false;
    this.displayState.gridDiv = true;
    return true;
  }

  showToast(msg: Message) {
    this.messageService.add(msg);
  }

  clear() {
    this.messageService.clear();
  }

  isDeveloper() {
    return this.utilService.isDeveloper();
  }

}
